import { Button } from '@/app/common/components/Button'
import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import Textarea from '@/app/common/components/Textarea/Textarea'
import { InfoCircleIcon } from '@/app/common/icons/general'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { Label } from '@/shad/ui/label'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import * as z from 'zod'

// Define the validation schema using Zod
const appealSchema = z.object({
  reasonForAppeal: z.string()
    .min(20, 'Please provide a detailed explanation (minimum 20 characters)')
})

// Infer TypeScript type from the schema
type AppealFormValues = z.infer<typeof appealSchema>

interface Props {
  onSubmit: (data: AppealFormValues) => void
}

function ExplainAppealPage(props: Props) {
  const { onSubmit } = props

  // Initialize React Hook Form with Zod resolver
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<AppealFormValues>({
    resolver: zodResolver(appealSchema),
    defaultValues: {
      reasonForAppeal: ''
    }
  })

  // Handle form submission
  const processSubmit = (data: AppealFormValues) => {
    onSubmit(data)
    // Navigate to next step or show success message
  }

  return (
    <FamilyWizardLayout>   
      <FamilyWizardLayout.Header className='max-h-none md:h-full'>
        Appeal Payment
        <p className='text-sm mt-2 text-center text-gray-600 font-normal max-w-md '>
        Provide a detailed explanation of why you believe the payment should be reconsidered. Include any relevant documentation or evidence to support your claim.

        </p>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className='space-y-4 max-w-2xl'>
        <form onSubmit={handleSubmit(processSubmit)} className='space-y-6 mt-6'>
          <div className='space-y-1'>
            <Label htmlFor="reasonForAppeal">
              Reason for appeal <span className="text-red-500">*</span>
            </Label>
            <Textarea
            rows={5}
              {...register('reasonForAppeal')}
              placeholder="Please explain why you are appealing this payment..."
            />
            {errors.reasonForAppeal && (
              <p className="text-red-500 text-sm mt-1">{errors.reasonForAppeal.message}</p>
            )}
          </div>

          <Card>
            <CardHeader className="flex flex-row items-center gap-2">
              <InfoCircleIcon className='text-blue-500' /> 
              <span className='font-medium'>Information</span>
            </CardHeader>
            <CardContent className='text-sm space-y-2'>
                <ul className='list-disc list-inside text-gray-600'>
                    <li>
                Please note that appeals without sufficient justification may be rejected.

                    </li>
                    <li>

                You will be able to adjust your payment information in the next steps.

                    </li>
                </ul>
            </CardContent>
          </Card>

          <div className="flex justify-end pt-4">
            <Button
              type="submit" 
              disabled={isSubmitting}
            >
              {'Continue'}
            </Button>
          </div>
        </form>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>   
  )
}

export default ExplainAppealPage